import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import {
  SupportTicket,
  SupportTicketComment,
  SupportTicketRequest
} from './SupportTickets.types';

export const getSupportTicketAsync = async (): Promise<
  ApiResponseType<SupportTicket[]>
> => {
  const { data } = await axios.get<ApiResponseType<SupportTicket[]>>(
    `/zendesk/tickets`
  );
  return data;
};

export const getCommentsSupportTicketAsync = async (
  id: number
): Promise<ApiResponseType<SupportTicketComment[]>> => {
  const { data } = await axios.get<ApiResponseType<SupportTicketComment[]>>(
    `/zendesk/tickets/${id}/comments`
  );
  return data;
};

// ✅ Create Support Ticket with File Uploads
export const createSupportTicketAsync = async (
  formData: FormData
): Promise<ApiResponseType<SupportTicket>> => {
  const { data } = await axios.post<ApiResponseType<SupportTicket>>(
    `/zendesk/tickets`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return data;
};

// ✅ Add Comment with File Uploads
export const addCommentSupportTicketAsync = async (
  id: number,
  formData: FormData
): Promise<ApiResponseType<SupportTicketComment>> => {
  const { data } = await axios.put<ApiResponseType<SupportTicketComment>>(
    `/zendesk/tickets/${id}/comments`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  );
  return data;
};
